<template>
  <div class="content">
    <div class="header">
      Infoauto
      <br />
    </div>
    <div class="navigation pb-5">
      <div class="bar">
        <button
          @click="selectedSection = 'currencies'"
          class="tablinks"
          :class="{ active: selectedSection == 'currencies' }"
        >
          Currencies
        </button>
        <button
          @click="selectedSection = 'payments'"
          class="tablinks"
          :class="{ active: selectedSection == 'payments' }"
        >
          Payments Types
        </button>
        <button
          @click="selectedSection = 'sellers'"
          class="tablinks"
          :class="{ active: selectedSection == 'sellers' }"
        >
          Sellers
        </button>
        <button
          @click="selectedSection = 'cargos'"
          class="tablinks"
          :class="{ active: selectedSection == 'cargos' }"
        >
          Charges
        </button>
        <button
          @click="selectedSection = 'countries'"
          class="tablinks"
          :class="{ active: selectedSection == 'countries' }"
        >
          Countries
        </button>
        <button
          @click="selectedSection = 'depositos'"
          class="tablinks"
          :class="{ active: selectedSection == 'depositos' }"
        >
          Depositos
        </button>
        <button
          @click="selectedSection = 'grupos_precios'"
          class="tablinks"
          :class="{ active: selectedSection == 'grupos_precios' }"
        >
          Grupos de precios
        </button>
        <button
          @click="selectedSection = 'departamentos'"
          class="tablinks"
          :class="{ active: selectedSection == 'departamentos' }"
        >
          Departamentos
        </button>
      </div>
    </div>
    <template v-if="selectedSection == 'currencies'">
      <Currencies></Currencies>
    </template>
    <template v-if="selectedSection == 'payments'">
      <PaymentsTypes></PaymentsTypes>
    </template>
    <template v-if="selectedSection == 'sellers'">
      <Sellers></Sellers>
    </template>
    <template v-if="selectedSection == 'cargos'">
      <Cargos></Cargos>
    </template>
    <template v-if="selectedSection == 'countries'">
      <Countries></Countries>
    </template>
    <template v-if="selectedSection == 'depositos'">
      <Depositos></Depositos>
    </template>
    <template v-if="selectedSection == 'grupos_precios'">
      <GruposPrecios></GruposPrecios>
    </template>
    <template v-if="selectedSection == 'departamentos'">
      <Departamentos></Departamentos>
    </template>
  </div>
</template>

<script>
import Currencies from "@/components/infoauto/Currencies.vue";
import PaymentsTypes from "@/components/infoauto/PaymentsTypes.vue";
import Sellers from "@/components/infoauto/Sellers.vue";
import Cargos from "@/components/infoauto/Cargos.vue";
import Countries from "@/components/infoauto/Address.vue";
import Depositos from "@/components/infoauto/Depositos.vue";
import GruposPrecios from "@/components/infoauto/GruposPrecios.vue";
import Departamentos from "@/components/infoauto/Departamentos.vue";

export default {
  name: "InfoautoPage",
  components: {
    Currencies,
    PaymentsTypes,
    Sellers,
    Cargos,
    Countries,
    Depositos,
    GruposPrecios,
    Departamentos
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      selectedSection: "currencies"
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";
</style>
